<template>
  <div>
    <ProgressBar :value="progress.currentStep" :max="progress.totalSteps" :content="progressContent" />
    <RouteStepper
      class="w-full mt-32 md:mt-60 md:max-w-[568px] px-16 mx-auto"
      :hideBreadcrumb="true"
      @progress="progress = $event"
      @submit="redirectToAccountCreation"
    />
  </div>
</template>

<script lang="ts">
import RouteStepper from '@/components/route_stepper/RouteStepper.vue';
import ProgressBar from '@/components/progress_bar/ProgressBar.vue';
import { OnboardingSeekerDraft } from './types';
import { redirect } from '@/helpers/redirects';

export default {
  name: 'OnboardingSeeker',
  components: { RouteStepper, ProgressBar },
  data(): { progress: { currentStep: number; totalSteps: number } } {
    return {
      progress: { currentStep: 1, totalSteps: 1 },
    };
  },
  computed: {
    progressContent(): string {
      return `Step ${this.progress.currentStep} of ${this.progress.totalSteps}`;
    },
  },
  methods: {
    redirectToAccountCreation({ zipCode }: OnboardingSeekerDraft): void {
      const params = new URLSearchParams({ member_type: 'seeker', skip_onboarding: 'true' });
      if (zipCode) {
        params.set('zip_code', zipCode);
      }
      redirect(`/registration?${params.toString()}`);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card:not(.card-preserve) {
  padding: 24px;

  @media (max-width: 640px) {
    background-color: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}
</style>
